import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { I18nInputComponent } from './i18n-input.component';

@NgModule({
  declarations: [I18nInputComponent],
  imports: [
    CommonModule,
    NzDropDownModule,
    FormsModule,
    TranslateModule
  ],
  exports: [I18nInputComponent]
})
export class I18nInputModule { }
